var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"cat-img",attrs:{"md8":"","xs11":""}},[_c('v-img',{attrs:{"src":("/img/categories/thumbs/" + _vm.catImage + ".jpg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }